/** Esconde a tela de splash com fade-out. */
export function esconderSplash() {
  const s = document.getElementById('splash');
  if (!s) return;
  s.classList.add('splash--hide');
  setTimeout(() => s.remove(), 400);
}
